import React, { useEffect, useState } from "react";
import "../../Pages/ProspectProfile/Profile.css";
import star from "../../Assets/Stargrey.png";
import phone from "../../Assets/phone.svg";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import linkedin from "../../Assets/linkedin.svg";
import visitLinkImage from "../../Assets/visit-link.svg";
import decisionMakerImage from "../../Assets/Cloudfigma.svg";
import {
  APISalesforceUrl,
  APIDataUrl,
  APITokenUrl,
  APIGraphUrl,
  GetOktaAuthData,
  GetUserId,
} from "../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import starRed from "../../Assets/starRed.svg";
import startgray from "../../Assets/Stargrey.png";
import linkedinprospects from "../../Assets/linkedinprospects.svg";
import twitterprospects from "../../Assets/twitterprospects.svg";
import facebookprospects from "../../Assets/facebookprospects.svg";
import MessageModal from "../MessageModal/MessageModal";
import PeopleDetailsFav from "../FavoritesList/AddToFavoriteModal/PeopleDetailsFav";
import SalesForceMessageModal from "../MessageModal/SalesForceMessageModal";
import activeSaleforceLogo from "../../Assets/activeSaleforceLogo.svg";
import { Box, Tab, Tabs } from "@mui/material";
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const ProspectDetails = ({
  strengthData,
  setIsSalesForceTrigger,
  isSalesForceTrigger,
  profileData,
  archiveRecord,
  setArchiveRecord,
  peopleId,
  trackRecord,
  setTrackRecord,
  addToFav,
  setAddToFav,
  setLoading,
  shareRecord,
  setShareRecord,
  organizationData,
  expDetails,
  setDisableTracking,
  fetchdata,
  value,
  setValue,
  
  
}) => {
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const loggedInUserId = GetUserId();
  const userInfo = GetOktaAuthData();
  const loggedUser = userInfo?.user?.profile;
  const [favoritesList, setFavoritesList] = React.useState([]);
  const [messageModal, setMessageModal] = useState(false);
  const [messageModalTrack, setMessageModalTrack] = React.useState(false);
  const [openCreateListmdl, setOpenCreateListmdl] = React.useState(false);
  const [messageModalSalesforce, setMessageModalSalesforce] =
    React.useState(false);
  const handleFavouriteLead = (row) => {
    setLoading(true);
    // const data = {
    //   "people_id": row.person_id
    // }
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      data: [row.person_id],
      url: `${APIDataUrl()}/favorites/people/list/add-record?user_id=${loggedInUserId}`,
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
        fetchdata();
        // toast.success("Prospect added to favorites")
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const handleRemoveFavouriteLead = () => {
    const option = {
      method: "DELETE",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/favorites/delete_favorites_people?user_id=${loggedInUserId}`,
      data: [peopleId],
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
        fetchdata();
        toast.success("Prospect removed from favorites");
      })
      .catch(() => {
        setLoading(false);
      });
  };
  // const handleFavouriteLead = (row) => {
  //   setLoading(true);
  //   const data = {
  //     user_id: Number(GetUserId()),
  //     people_id: Number(peopleId),
  //   };
  //   const option = {
  //     method: "POST",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "content-type": "application/json",
  //       "X-API-Key": APITokenUrl(),
  //     },
  //     data: data,
  //     url: `${APIDataUrl()}/v1/save_favourite_prospect`,
  //   };
  //   axios(option)
  //     .then(async (response) => {
  //       setLoading(false);
  //       toast.success("Prospect added to favorites");
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //     });
  // };
  // const handleRemoveFavouriteLead = () => {
  //   setLoading(true);
  //   const data = favoritesList?.find(
  //     (item) => item?.person_id == Number(peopleId)
  //   );
  //   const option = {
  //     method: "POST",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "content-type": "application/json",
  //       "X-API-Key": APITokenUrl(),
  //     },
  //     url: `${APIDataUrl()}/v1/remove_favourite_prospect?id=${data?.favourites_id
  //       }`,
  //   };
  //   axios(option)
  //     .then(async (response) => {
  //       setLoading(false);
  //       toast.success("Prospect removed from favorites");
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //     });
  // };
  const listFavoriteRecords = async () => {
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/list_favourite_prospects?userid=${Number(
        GetUserId(),
      )}&limit=200&offset=0`,
    };
    try {
      const response = await axios(options);
      setFavoritesList(response?.data?.data);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
    }
  };
  useEffect(() => {
    listFavoriteRecords();
  }, []);
  React.useEffect(() => {
    if (archiveRecord == true) {
      setMessageModal(true);
      setArchiveRecord(false);
      // handleArchiveRecords()
    }
  }, [archiveRecord]);
  React.useEffect(() => {
    if (addToFav == true) {
      setOpenCreateListmdl(true);
      setAddToFav(false);
      // handleArchiveRecords()
    }
  }, [addToFav]);
  const handleArchiveRecords = async () => {
    setLoading(true);
    const data = [
      {
        user_id: Number(GetUserId()),
        people_id: Number(peopleId),
      },
    ];
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIDataUrl()}/v1/send_archive`,
    };
    try {
      const response = await axios(options);
      setArchiveRecord(false);
      setMessageModal(false);
      setLoading(false);
      if (favoritesList?.some((item) => item?.person_id === Number(peopleId))) {
        handleRemoveFavouriteLead();
      }
      if (response?.data?.message === "Already archived") {
        toast.success("Prospects already Archived.");
      } else {
        toast.success("Prospects Archived Successfully");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
    }
  };
  const handleTrackRecords = () => {
    setLoading(true);
    const data = [peopleId];
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIDataUrl()}/v1/save_tracking_prospect?user_id=${Number(
        GetUserId(),
      )}`,
    };
    axios(option)
      .then((response) => {
        if (response.status === 200) {
          setLoading(false);
          setTrackRecord(false);
          setMessageModalTrack(false);
          setDisableTracking(true);
          toast.success("Tracking Added");
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.message);
      });
  };
  React.useEffect(() => {
    if (trackRecord == true) {
      setMessageModalTrack(true);
      setTrackRecord(false);
    }
  }, [trackRecord]);
  React.useEffect(() => {
    if (shareRecord === true) {
      const subject = encodeURIComponent(
        `${profileData?.first_name ? profileData?.first_name : "-"} ${
          profileData?.last_name ? profileData?.last_name : "-"
        } profile`,
      );
      const body =
        encodeURIComponent(`Please find the attached link.`) +
        "%0D%0A" +
        encodeURIComponent(`${window.location.href}`);
      const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=${subject}&body=${body}`;
      setShareRecord(false);
      window.open(gmailLink, "_blank");
    }
  }, [shareRecord]);
  const pushToSalesForce = () => {
    setLoading(true);
    const ms = {
      updateData: {
        data: [
          {
            items: [profileData?.person_id, "Suspect"],
          },
        ],
      },
    };
    const allData = [profileData];
    const transformedData = allData
      ?.map((i) => {
        const organizationInfo =
          allData.find((org) => org?.org_id === i?.org_id) || {};
        return { ...i, organizationInfo };
      })
      ?.map((item) => ({
        attributes: {
          type: "Lead",
          referenceId: "rec" + item?.person_id,
        },
        LastName: item?.last_name,
        FirstName: item?.first_name,
        Salutation: null,
        Email: item?.email,
        Phone: item?.phone_no,
        Title: item?.primary_job_title,
        Company: item?.primary_organization,
        City: item?.organizationInfo?.location_identifiers?.split(",")[0],
        State: item?.organizationInfo?.location_identifiers?.split(",")[1],
        Country: item?.organizationInfo?.country,
        LeadSource: "JOI",
        Status: "Suspect",
        LinkedIn_Profile__c: item?.linkedin,
        Suspect_Source_Detail__c: `${loggedUser?.firstName} ${loggedUser?.lastName}`,
      }));
    const finalJson = { records: transformedData, ...ms };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      data: finalJson,
      url: `${APISalesforceUrl()}/v1/add_suspects`,
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
        if (response?.status === 200) {
          toast.success("Record has been created");
          setMessageModalSalesforce(false);
          setIsSalesForceTrigger(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  React.useEffect(() => {
    if (isSalesForceTrigger) {
      setMessageModalSalesforce(true);
      // pushToSalesForce();
    }
  }, [isSalesForceTrigger]);
  return (
    <>
    <div className="p-details-main-outer">
      <div className="p-details-main" style={{ width: "100%" }}>
        <div
          className="salesforce-plus-names col-md-3"
          style={{ width: "25%" }}
        >
          <div
            className={
              profileData?.decision_maker === true
                ? "Decision-maker-user-name-profile"
                : "Decision-maker-user-noborder create-name-img border-change-profile"
            }
          >
            <img
              className={
                profileData?.suspect_status === null
                  ? "hide-image"
                  : "decisionMakerImageAi-Decisionmaker-pd-profile"
              }
              src={
                profileData?.journey_status === "project created"
                  ? activeSaleforceLogo
                  : decisionMakerImage
              }
              alt=""
            />

            <p className="letter-heading">
              {profileData?.first_name
                ? profileData?.first_name
                    ?.split(" ")
                    ?.find((item) => !item.includes("("))
                    ?.charAt(0)
                : ""}
              {profileData?.last_name
                ? profileData?.last_name
                    ?.split(" ")
                    ?.find((item) => !item.includes("("))
                    ?.charAt(0)
                : ""}
            </p>
          </div>
          <div className="profiles-contents">
            <p className="name-profile-mention-prospects">
              {profileData?.first_name === "jp"
                ? "JP"
                : profileData?.first_name || "-"}
              &nbsp;
              {/* {profileData?.first_name ? profileData?.first_name : "-"}&nbsp; */}
              {profileData?.last_name ? profileData?.last_name : "-"}
            </p>
            {/* <p className="company-profile-mention-b1"> {expDetails?.[0]?.job_title} </p> */}
            <p className="company-profile-mention-b1">
              {" "}
              {profileData?.raw_job_title}{" "}
            </p>
            <p className="company-profile-mention-b1">
              {profileData?.primary_job_title
                ? profileData?.primary_job_title
                : "-"}
            </p>
            <p className="company-profile-mention-b1">
              {profileData?.primary_organization
                ? profileData?.primary_organization
                : "-"}
            </p>
            <p className="social-media-icons">
              {profileData?.linkedin ? (
                <a
                  href={profileData.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={linkedinprospects} alt="LinkedIn" />
                </a>
              ) : null}
              {profileData?.twitter ? (
                <a
                  href={profileData.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={twitterprospects} alt="Twitter" />
                </a>
              ) : null}
              {profileData?.facebook ? (
                <a
                  href={profileData.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={facebookprospects} alt="Facebook" />
                </a>
              ) : null}
            </p>
          </div>
        </div>
        <div className="" style={{ width: "25%" }}>
          <div className="profiles-contents">
            <a
              href={`mailto:${profileData?.email || ""}`}
              target="_blank"
              className="mail-details-profile-pg"
            >
              <p className="company-profile-mention">
                <EmailOutlinedIcon
                  style={{
                    color: "#003057",
                    width: "16px",
                    height: "16px",
                  }}
                />
                {profileData?.email ? profileData?.email : "-"}
              </p>
            </a>

            {profileData?.emails &&
              profileData.emails
                .split(",")
                .filter((em) => em.trim() !== profileData.email)
                .map((email, index) => (
                  <a
                    key={index}
                    href={`mailto:${email}`}
                    target="_blank"
                    className="mail-details-profile-pg"
                  >
                    <p className="company-profile-mention">
                      <EmailOutlinedIcon
                        style={{
                          color: "#003057",
                          width: "16px",
                          height: "16px",
                        }}
                      />
                      {email}
                    </p>
                  </a>
                ))}

            <p className="company-profile-mention">
              <img
                src={phone}
                alt=""
                style={{ width: "16px", height: "16px" }}
              />
              {profileData?.phone_no ? profileData?.phone_no : "-"}
            </p>

            {profileData?.other_phone ? (
              <p className="company-profile-mention">
                <img
                  src={phone}
                  alt=""
                  style={{ width: "16px", height: "16px" }}
                />
                {profileData?.other_phone ? profileData?.other_phone : "-"}
              </p>
            ) : null}
            {profileData?.home_phone ? (
              <p className="company-profile-mention">
                <img
                  src={phone}
                  alt=""
                  style={{ width: "16px", height: "16px" }}
                />
                {profileData?.home_phone ? profileData?.home_phone : "-"}
              </p>
            ) : null}
          </div>
        </div>
        <div className="" style={{ width: "25%" }}>
          <div className="profiles-contents">
            <p className="com-details-profile">
              Orbit Strength: <p>{strengthData ? strengthData : "-"}</p>
            </p>
            <p className="com-details-profile">
              Industry:
              <p>
                {" "}
                {profileData?.categories
                  ? profileData?.categories
                      ?.split("/(?<=,)|s+/")
                      .map(
                        (word) =>
                          word.charAt(0).toUpperCase() +
                          word.slice(1).toLowerCase(),
                      )
                      .join(" ")
                  : "-"}
              </p>
            </p>
            <p className="com-details-profile">
              Orbit Status:
              {profileData?.suspect_status
                ? profileData?.suspect_status
                : "-"}
            </p>
          </div>
        </div>
        <div className="" style={{ width: "10%" }}>
          <div className="profiles-contents-last">
            {/* <p className='com-details-profile-b3'>Select: <span className='pro-pro-span'> <input
        type="checkbox"
        onChange={(e) => setRowsSelect(e?.target?.checked)}
        checked={rowsSelect}
      /></span> </p> */}

            {/* 
      <p className="com-details-profile-b3">
        Add to Favorites:
        {profileData?.isFavourite ? <span
          className="pro-pro-span"
          onClick={() => handleRemoveFavouriteLead(profileData)}
        >
          <img src={starRed} alt="" />
        </span> : <span
          className="pro-pro-span"
          onClick={() => handleFavouriteLead(profileData)}
        >
          <img src={startgray} alt="" />
        </span>}
      </p> */}
          </div>
        </div>

        {/* <MessageModal
    open={messageModalSalesforce}
    setOpen={setMessageModalSalesforce}
    message="Are you sure that you want to push these records to Salesforce?"
    handleSubmit={pushToSalesForce}
  /> */}
        <SalesForceMessageModal
          open={messageModalSalesforce}
          setOpen={setMessageModalSalesforce}
          selectedOuterRows={[profileData]}
          setSelectedOuterRows={() => {}}
          setIsSalesForceTrigger={setIsSalesForceTrigger}
          decisionMakerData={[profileData]}
          setLoading={setLoading}
        />
        <MessageModal
          open={messageModal}
          setOpen={setMessageModal}
          message="Are you sure that you want to archive this record?"
          handleSubmit={handleArchiveRecords}
          // favoritesList={favoritesList}
          // listFavoriteRecords={listFavoriteRecords}
        />
        <MessageModal
          open={messageModalTrack}
          setOpen={setMessageModalTrack}
          message="Are you sure that you want to add this record to tracking?"
          handleSubmit={handleTrackRecords}
        />
        <PeopleDetailsFav
          profileData={[profileData?.person_id]}
          open={openCreateListmdl}
          fetchdata={fetchdata}
          setOpen={setOpenCreateListmdl}
          message={`Are you sure that you want to add this record to Favorites?`}
        />
      </div>
      <div className="p-details-main-lower">
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            className="Companydata"
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              label="Experience | Education | Organization"
              {...a11yProps(0)}
            />
            <Tab
              label="Prospect and Relationship Intelligence Explorer (PRIE)"
              {...a11yProps(1)}
            />
            <Tab label="News/ Events" {...a11yProps(2)} />
          </Tabs>
        </Box>
      </div>
    </div>
    </>
  );
};
export default ProspectDetails;
